(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function FeaturesTabs(elem) {
        Behaviors.init(FeaturesTabs, this, arguments);

        var $thisElem = this.$elem,
        tabNav = $thisElem.find('a'),
        tab = $thisElem.parents('.FeaturesTabs').find('.FeaturesTabs-tab');

        // Team Filters
        tabNav.on("click", function (e) {
            e.preventDefault();

            var $this = $(this),
                tabTarget = $this.attr('href');
                console.log(tabTarget);

                if ( !$this.parent().hasClass('FeaturesTabs-tab_nav--active')) {
                    tabNav.parent().removeClass('FeaturesTabs-tab_nav--active');
                    tab.removeClass('FeaturesTabs-tab--active')

                    $this.parent().addClass('FeaturesTabs-tab_nav--active');

                    $thisElem.parents('.FeaturesTabs').find(tabTarget).addClass('FeaturesTabs-tab--active')
                }
        });
    }

    Behaviors.inherit(FeaturesTabs, Behaviors.Behavior);

    FeaturesTabs.QUERY = "[data-features-tabs]";

    Behaviors.register_behavior(FeaturesTabs);

    module.FeaturesTabs = FeaturesTabs;

    return module;

}(window.jQuery, window.Behaviors));